import { log } from "../../../logging";
import { getGame } from "../../gamemode_management/util/getGame";
import { nexusGames } from "../util";
import { nexusGameId } from "./convertGameId";
const gameNum = (() => {
    let cache;
    let gamesList;
    return (gameId) => {
        const games = nexusGames();
        if (cache === undefined || gamesList !== games) {
            if (games.length > 0) {
                cache = games.reduce((prev, game) => {
                    prev[game.domain_name] = game.id;
                    return prev;
                }, {});
                gamesList = games;
            }
        }
        if (cache === undefined) {
            return undefined;
        }
        const game = getGame(gameId);
        return cache[nexusGameId(game, gameId)];
    };
})();
export function makeFileUID(repoInfo) {
    // check if gameId is numeric and if not, use gameNum() to convert
    const gameIdNum = /^\d+$/.test(repoInfo.gameId)
        ? parseInt(repoInfo.gameId, 10)
        : gameNum(repoInfo.gameId);
    if (gameIdNum === undefined || isNaN(gameIdNum)) {
        return undefined;
    }
    const fileId = parseInt(repoInfo.fileId, 10);
    if (isNaN(fileId)) {
        return undefined;
    }
    return ((BigInt(gameIdNum) << BigInt(32)) | BigInt(fileId)).toString();
}
export function makeModUID(repoInfo) {
    // check if gameId is numeric and if not, use gameNum() to convert
    const gameIdNum = /^\d+$/.test(repoInfo.gameId)
        ? parseInt(repoInfo.gameId, 10)
        : gameNum(repoInfo.gameId);
    if (gameIdNum === undefined || isNaN(gameIdNum)) {
        return undefined;
    }
    const modId = parseInt(repoInfo.modId, 10);
    if (isNaN(modId)) {
        return undefined;
    }
    return ((BigInt(gameIdNum) << BigInt(32)) | BigInt(modId)).toString();
}
export function makeModAndFileUIDs(gameId, modId, fileId) {
    // 1303 518 138454
    const repoInfo = { gameId, modId, fileId };
    if (process.env.NODE_ENV === "development") {
        log("debug", "makeModAndFileUIDs", JSON.stringify(repoInfo));
    }
    // Early return if gameId, modId or fileId is missing or invalid
    if (!repoInfo.gameId ||
        !repoInfo.modId ||
        !repoInfo.fileId ||
        isNaN(parseInt(repoInfo.modId, 10)) ||
        isNaN(parseInt(repoInfo.fileId, 10))) {
        return { modUID: undefined, fileUID: undefined };
    }
    const gameIdNum = /^\d+$/.test(repoInfo.gameId)
        ? parseInt(repoInfo.gameId, 10)
        : gameNum(repoInfo.gameId);
    if (gameIdNum === undefined || isNaN(gameIdNum)) {
        return { modUID: undefined, fileUID: undefined };
    }
    return {
        modUID: makeModUID(repoInfo),
        fileUID: makeFileUID(repoInfo),
    };
}
